import React from "react";
import ChemoAnalytics from "@/components/ChemoAnalytics";
import AIInsightsPanel from "@/components/AIInsightsPanel";
import WellnessAssessmentModal from "@/components/WellnessAssessmentModal";

export default function AnalyticsTabPanel({
  patientId,
  analyticsData,
  showAssessmentModal,
  onOpenAssessment,
  onCloseAssessment,
  onAssessmentSaved,
}) {
  return (
    <div data-testid="chemo-analytics-wrapper" className="bg-white border border-stone-200 rounded-xl shadow-soft overflow-hidden">
      <div className={`px-4 py-2 border-b text-xs flex items-center justify-between gap-4 ${analyticsData ? "bg-emerald-50 border-emerald-200 text-emerald-800" : "bg-amber-50 border-amber-200 text-amber-800"}`}>
        <div>
          {analyticsData ? (
            <><b>Live data:</b> showing this patient's {analyticsData.totalEffects} reported effects, compliance {analyticsData.compliancePct}%, wellness score {analyticsData.overallWellnessScore}/100.
              {analyticsData.wellnessAssessment && (
                <span> · Wellness scores recorded {new Date(analyticsData.wellnessAssessment.recorded_at).toLocaleString()} by {analyticsData.wellnessAssessment.recorded_by_name}.</span>
              )}
            </>
          ) : (
            <><b>Loading…</b> fetching this patient's analytics.</>
          )}
        </div>
        <button
          onClick={onOpenAssessment}
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-emerald-600 hover:bg-emerald-700 text-white text-xs font-semibold whitespace-nowrap shadow-sm"
          data-testid="open-wellness-assessment-btn"
        >
          Record wellness assessment
        </button>
      </div>
      <AIInsightsPanel patientId={patientId} />
      <ChemoAnalytics data={analyticsData} />
      {showAssessmentModal && (
        <WellnessAssessmentModal
          patientId={patientId}
          initialComponents={analyticsData?.wellnessComponents?.map((c) => ({ label: c.label, score: c.score })) || []}
          onClose={onCloseAssessment}
          onSaved={onAssessmentSaved}
        />
      )}
    </div>
  );
}
